import React from 'react';
import './TopBar.css';
import {NotificationsNone,Settings,Language} from '@material-ui/icons';

function TopBar() {
  return (
    <div className='topBar'>
       <div className="topBarWrapper">
           <div className="topLeft"><span className='logo'>React Admin</span></div>
             <div className="topRight">
               <div className="topBarIconContainer">
                    <NotificationsNone />
                    <span className='topIconBadge'>1</span>
               </div>
              
               <div className="topBarIconContainer">
                    <Language />
                    <span className='topIconBadge'>3</span>
               </div>
               <div className="topBarIconContainer">
                    <Settings />
               </div>
               <img src='https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt="" className="profile" />
           
            </div>
               
       </div>
    </div>
  )
}

export default TopBar